import { claimIdentity } from '../../webmodule-common/other/api/user-security';
import { currentUserClaims } from '../../webmodule-common/other/currentuser-claims';
import { tlang } from '../../webmodule-common/other/language/lang';
import { lockUIandExecute } from '../../webmodule-common/other/ui-lock';
import { information } from '../../webmodule-common/other/ui/modal-option';

import { getApiFactory } from '../api/api-injector';
import { FranchiseeNetworkApi } from '../api/franchisee-network-api';
import { SupportInboxItemType, ViewSupportInboxItemEx } from '../api/supplier-api-interface-franchiseenetwork';
import { FranchiseeBranchDeploymentView } from '../dealer/data/franchisee-branch-deployment-view';
import { userDataStore } from '../supplier/common/current-user-data-store';

export async function getPAT(item: { branchId: string; tenantId: number; dealerDeploymentId: number }) {
  return await lockUIandExecute(async () => {
    const franchiseeApi: FranchiseeNetworkApi = getApiFactory().franchisee();
    const claims = {};
    //this sets the branch they will navigate to
    claims[claimIdentity.branchId] = item.branchId;
    //indicates supplier level privelages
    claims[claimIdentity.agent] = 'true';
    claims[claimIdentity.frameConfigPowerUser] = currentUserClaims().isPowerUser ? 'true' : 'false';
    //allow suppliers to administer dealer staff.
    claims[claimIdentity.admin] = 'true';

    return (
      await franchiseeApi.pat({
        preferredLifeOfTokenHours: 8,
        tenantId: item.tenantId,
        dealerDeploymentId: item.dealerDeploymentId,
        claims: claims
      })
    )?.pat;
  });
}

export async function loginAsFranchisee(item: FranchiseeBranchDeploymentView) {
  const pat = await getPAT({ branchId: item.branchId, tenantId: item.tenantId, dealerDeploymentId: item.deploymentId });
  if (pat) {
    window.open(`${item.deploymentDomain}?PAT=${pat}`, '_blank', 'noopener=true');
  }
}

export async function loginAsFranchiseeForSupportTicket(item: ViewSupportInboxItemEx) {
  const pat = await getPAT({
    branchId: item.item.branchId,
    tenantId: item.item.franchiseeTenantId,
    dealerDeploymentId: item.item.dealerDeploymentId
  });
  if (!pat) {
    await information(tlang`Cannot login to the franchisee branch for this support ticket`);
    return;
  }

  const deployment = userDataStore.allFranchiseeDetails.tenantList.deployments?.find(
    x => x.dealerDeploymentId === item.item.dealerDeploymentId
  );
  //https://www.kuaka-testing.softtech.com/quotes/03109e02-0353-4e05-af96-c029b3559290
  if (!deployment) {
    await information(tlang`Cannot resolve the link for this data`);
  }
  const url = `${deployment?.uiDomain}/quotes/${item.item.quoteId}`;
  const fragment =
    item.item.type == SupportInboxItemType.QuoteAssistanceRequest ||
    item.item.type == SupportInboxItemType.EngineeredToOrder
      ? `#support_${item.item.conversationId}`
      : '';

  window.open(`${url}?PAT=${pat}${fragment}`, '_blank', 'noopener=true');
}
